import React, {useEffect, useState} from 'react';
import DatePicker from "react-datepicker";
import ReactModal from "react-modal";
import Select from "react-select";

import "./TrainingCapture.css";
import {StandardButton} from "../../common/button/standard-button/StandardButton";
import {retrieveAllTrainingModules} from "../../../services/TrainingModuleService";
import {TrainingCaptureModal} from "./training-capture-modal/TrainingCaptureModal";
import {
    createTrainingPackage,
    deleteTrainingPackage,
    retrieveAllTrainingGroups,
    updateTrainingPackage,
} from "../../../services/TrainingService";
import {retrieveAllGrants} from "../../../services/GrantService";
import {TrainingFileUploadButton} from "../../common/button/file-upload-button/TrainingFileUploadButton";
import {appBaseURL, downloadURL} from "../../../config/URLConfig";
import {ConfirmDeleteModal} from "../../common/confirmation-modal/ConfimDeleteModal";
import {convertDateToUTC} from "../../../util/DateUtil";

export const TrainingCapture = ({context, setSpinnerText, showToaster, navigateTo, navigateBack}) => {

    ReactModal.setAppElement('#root');

    const [showTrainingModal, setShowTrainingModal] = useState(false);
    const [startDateOfTraining, setStartDateOfTraining] = useState(null);
    const [endDateOfTraining, setEndDateOfTraining] = useState(null);
    const [trainingModuleList, setTrainingModuleList] = useState([]);
    const [trainingModuleListForDisplay, setTrainingModuleListForDisplay] = useState([]);
    const [location, setLocation] = useState("");
    const [retrievedGrantList, setRetrievedGrantList] = useState([]);
    const [selectedGrant, setSelectedGrant] = useState(null);
    const [retrievedTrainingGroupList, setRetrievedTrainingGroupList] = useState([]);
    const [selectedTrainingGroupList, setSelectedTrainingGroupList] = useState([]);
    const [file, setFile] = useState(null);
    const [extRefToBeDeleted, setExtRefToBeDeleted] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [numberOfPeopleTrained, setNumberOfPeopleTrained] = useState("");
    const [selectedLevelOfTrainingList, setSelectedLevelOfTrainingList] = useState([]);
    const [levelOfTrainingList] = useState([
        {value: "National", label: "National"},
        {value: "Provincial", label: "Provincial"},
        {value: "District", label: "District"},
        {value: "Sub District", label: "Sub District"},
        {value: "Facility", label: "Facility"},
        {value: "Other", label: "Other"},
    ]);

    useEffect(() => {
        const fetchGroups = async () => {
            const [data, error] = await retrieveAllTrainingGroups(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    const mappedGroups = data.trainingGroupVOList.map((group) => {
                        return {
                            value: group.externalReference,
                            label: group.name,
                            memberCount: group.groupMembers.length
                        }
                    });
                    setRetrievedTrainingGroupList(mappedGroups);
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
        }
        fetchGroups();

        const fetchGrants = async () => {
            const [data, error] = await retrieveAllGrants(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    const mappedGrants = data.grantVOS.map((grant) => {
                        return {value: grant.externalReference, label: grant.name}
                    });
                    setRetrievedGrantList(mappedGrants);
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
        }
        fetchGrants();

        const fetchTrainingModules = async () => {
            const [data] = await retrieveAllTrainingModules(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    let mappedTrainingModules = data.trainingModuleVOList.map((trainingModule) => {
                        return {...trainingModule, isSelected: false, moduleName: trainingModule.name};
                    });
                    if (!context.newTrainingSelected) {
                        mappedTrainingModules.forEach((trainingModule) => {
                            context.selectedTraining.module.forEach((selectedTrainingModule) => {
                                if (trainingModule.externalReference === selectedTrainingModule.externalReference) {
                                    trainingModule.isSelected = true;
                                }
                            })
                        })
                    }
                    setTrainingModuleList(mappedTrainingModules);
                }
            }
        };
        fetchTrainingModules();

        if (context.newTrainingSelected) {
            setStartDateOfTraining(null);
            setEndDateOfTraining(null);
            setLocation("");
            setFile(null);
            setSelectedGrant("");
            setNumberOfPeopleTrained("");
            setSelectedTrainingGroupList([])
            setSelectedLevelOfTrainingList([]);
            setTrainingModuleListForDisplay([]);
        } else {
            if (context.selectedTraining) {
                setStartDateOfTraining(new Date(context.selectedTraining.startDate));
                setEndDateOfTraining(new Date(context.selectedTraining.endDate));
                setLocation(context.selectedTraining.trainingLocation);
                if (context.selectedTraining.grant) {
                    const mappedGrant = {
                        value: context.selectedTraining.grant.externalReference,
                        label: context.selectedTraining.grant.name,
                    }
                    setSelectedGrant(mappedGrant);
                } else {
                    setSelectedGrant(null);
                }
                const mappedSelectedGroups = context.selectedTraining.trainingGroupVOS.map((group) => {
                    return {value: group.externalReference, label: group.name, memberCount: group.groupMembers.length}
                });
                setSelectedTrainingGroupList(mappedSelectedGroups);
                const levelOfTrainingList = context.selectedTraining.levelOfTraining.map((levelOfTrainingStr) => {
                    return {value: levelOfTrainingStr, label: levelOfTrainingStr};
                });
                setSelectedLevelOfTrainingList(levelOfTrainingList);
                setNumberOfPeopleTrained(context.selectedTraining.numberOfPeopleTrained);
                let mappedTrainingModulesForDisplay = context.selectedTraining.module.map((trainingModule) => {
                    return {value: trainingModule.trainingModule, label: trainingModule.trainingModule};
                });
                setTrainingModuleListForDisplay(mappedTrainingModulesForDisplay);
            }
        }
    }, [context.newTrainingSelected]);

    useEffect(() => {
        if (null !== file) {
            if (!fileList.some(fileInList => fileInList.name === file.name)) {
                setFileList((prevState) => ([...prevState, file]));
            }
        }
    }, [file]);

    const handleTrainingProvidedClick = () => {
        setShowTrainingModal(true);
    }

    const handleCreateOrUpdateTrainingClick = async () => {
        setSpinnerText("Saving Training");
        let selectedTrainingModules = trainingModuleList.filter(trainingModule => trainingModule.isSelected);
        let grant = null;
        if (selectedGrant) {
            grant = {
                externalReference: selectedGrant.value,
            };
        }
        let trainingPackageExtRef = null;
        if (!context.newTrainingSelected) {
            trainingPackageExtRef = context.selectedTraining.externalReference;
        }
        let trainingPackage = {
            startDate: convertDateToUTC(startDateOfTraining),
            endDate: convertDateToUTC(endDateOfTraining),
            numberOfPeopleTrained: numberOfPeopleTrained,
            trainingLocation: location,
            trainingGroupVOS: selectedTrainingGroupList.map((group) => {
                return {externalReference: group.value};
            }),
            grant,
            module: selectedTrainingModules.map((module) => {
                return {externalReference: module.externalReference};
            }),
            levelOfTraining: selectedLevelOfTrainingList.map((levelOfTraining) => {
                return levelOfTraining.label;
            }),
            trainingFiles: fileList,
            externalReference: trainingPackageExtRef
        }

        if (context.newTrainingSelected) {
            const [data, error] = await createTrainingPackage(context.username, trainingPackage);
            if (data) {
                if (data.responseStatus === "Success") {
                    await resetScreen();
                    showToaster({
                        responseStatus: "Success",
                        responseMessage: "Training Session Created",
                    });
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }

            setSpinnerText(null);
            navigateTo("trainingSearch");

        } else {
            const [data, error] = await updateTrainingPackage(context.username, trainingPackage);
            if (data) {
                if (data.responseStatus === "Success") {
                    await resetScreen();
                    showToaster({
                        responseStatus: "Success",
                        responseMessage: "Training Session Updated",
                    });
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }

            setSpinnerText(null);
            navigateTo("trainingSearch");
        }
    }

    const handleDeleteTrainingClick = async () => {
        setSpinnerText("Deleting Training");
        let trainingDeleted = false;
        const [data, error] = await deleteTrainingPackage(context.username, context.selectedTraining.externalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                trainingDeleted = true;
                showToaster({
                    responseStatus: "Success",
                    responseMessage: "Training Session Deleted",
                });
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        if (trainingDeleted) {
            navigateTo("trainingSearch");
        }
        setSpinnerText(null);
    }

    const handleFileDownloadClick = () => {
        window.open(appBaseURL + downloadURL + context.selectedTraining.trainingFiles[0].externalReference);
    }

    const resetScreen = async () => {
        setEndDateOfTraining(null);
        setStartDateOfTraining(null);
        setLocation("");
        setFile(null);
        setNumberOfPeopleTrained("");
        setSelectedLevelOfTrainingList(null);
        const copyOfTrainingModuleList = JSON.parse(JSON.stringify(trainingModuleList));
        const mappedTrainingModuleList = copyOfTrainingModuleList.map((trainingModule) => {
            return {...trainingModule, isSelected: false};
        })
        setTrainingModuleList([...mappedTrainingModuleList]);
    }

    const handleTrainingModalButtonClick = () => {
        setShowTrainingModal(false);
        const selectedTrainingList = [];
        trainingModuleList.forEach((trainingModule) => {
            if (trainingModule.isSelected) {
                selectedTrainingList.push(trainingModule);
            }
        });
        let mappedTrainingModulesForDisplay = selectedTrainingList.map((trainingModule) => {
            return {value: trainingModule.trainingModule, label: trainingModule.trainingModule};
        });
        setTrainingModuleListForDisplay(mappedTrainingModulesForDisplay)
    }

    const handleGroupsTrainedChange = async (selectedGroups) => {
        setSelectedTrainingGroupList(selectedGroups);
        let numberOfGroupMembersArr = selectedGroups.map((group) => {
            return group.memberCount;
        });
        const sum = numberOfGroupMembersArr.reduce(function (groupMemberNumber1, groupMemberNumber2) {
            return groupMemberNumber1 + groupMemberNumber2;
        }, 0);
        setNumberOfPeopleTrained(sum);
    }

    const handleDeleteModalShow = async (extRef) => {
        setShowModal(true);
        setExtRefToBeDeleted(extRef);
    }

    return (
        <div className="training-capture-container">
            <div className="training-input-container">

                <div className="input-container-training-item">
                    <div className={"left-label-text-input-container"}>
                        <label className={"date-picker-label"}>Start Date:</label>
                        <DatePicker selected={startDateOfTraining}
                                    className="text-input-training-item"
                                    dateFormat="dd/MM/yyy"
                                    showPopperArrow={false}
                                    placeholderText="Select..."
                                    onChange={(selectedDate) => {
                                        setStartDateOfTraining(selectedDate);
                                    }}/>
                    </div>
                </div>

                <div className="input-container-training-item">
                    <div className={"left-label-text-input-container"}>
                        <label className={"date-picker-label"}>End Date:</label>
                        <DatePicker selected={endDateOfTraining}
                                    className="text-input-training-item"
                                    dateFormat="dd/MM/yyy"
                                    showPopperArrow={false}
                                    placeholderText="Select..."
                                    onChange={(selectedDate) => {
                                        setEndDateOfTraining(selectedDate);
                                    }}/>
                    </div>
                </div>

                <div className="input-container-training-item">
                    <div className={"left-label-text-input-container"}>
                        <label className={"bold"}>Location:</label>
                        <input className="text-input-training-item"
                               type="text"
                               value={location}
                               onChange={({target}) => {
                                   setLocation(target.value)
                               }}/>
                    </div>
                </div>

                <div className="input-container-training-item">
                    <div className={"training-left-label-text-input-container"}>
                        <label className={"bold"}>Grant:</label>
                        <Select options={retrievedGrantList}
                                closeMenuOnSelect={true}
                                onChange={(selectedGrantClick) => {
                                    setSelectedGrant(selectedGrantClick)
                                }}
                                value={selectedGrant}
                                classNamePrefix="training-capture-select"/>
                    </div>
                </div>

                <div className="input-container-training-item">
                    <div className={"training-left-label-text-input-container"}>
                        <label className={"bold"}>Group(s) Trained:</label>
                        <Select options={retrievedTrainingGroupList}
                                isMulti
                                closeMenuOnSelect={true}
                                onChange={handleGroupsTrainedChange}
                                value={selectedTrainingGroupList}
                                classNamePrefix="training-capture-select"/>
                    </div>
                </div>

                <div className="input-container-training-item">
                    <div className={"left-label-text-input-container"}>
                        <label className={"bold"}>Number of People Trained:</label>
                        <input className="text-input-training-item"
                               value={numberOfPeopleTrained}
                               type="text"
                               onChange={({target}) => {
                                   const numberOnlyRegExp = /^[0-9]*$/;
                                   if (numberOnlyRegExp.test(target.value)) {
                                       setNumberOfPeopleTrained(target.value)
                                   }
                               }}/>
                    </div>
                </div>

                <div className="input-container-training-item">
                    <div className={"training-left-label-text-input-container"}>
                        <label className={"bold"}>Level of Training:</label>
                        <Select options={levelOfTrainingList}
                                isMulti
                                closeMenuOnSelect={false}
                                onChange={(selectedLevel) => {
                                    setSelectedLevelOfTrainingList(selectedLevel)
                                }}
                                value={selectedLevelOfTrainingList}
                                classNamePrefix="training-capture-select"/>
                    </div>
                </div>

                {trainingModuleListForDisplay.length > 0 &&
                <div className="input-container-training-item">
                    <div className={"training-left-label-text-input-container"}>
                        <label className={"bold"}>Training Provided:</label>
                        <Select isMulti
                                isClearable={false}
                                isDisabled
                                components={{DropdownIndicator: () => null, IndicatorSeparator: () => null}}
                                styles={{
                                    multiValueRemove: (base) => ({...base, display: 'none'}),
                                    control: (styles) => {
                                        return {
                                            ...styles,
                                            backgroundColor: 'white',
                                        }
                                    }
                                }}
                                value={trainingModuleListForDisplay}
                                classNamePrefix="training-capture-select"/>
                    </div>
                </div>}

            </div>
            <div className="training-capture-button-container">
                <StandardButton text="Training Provided"
                                onClick={handleTrainingProvidedClick}/>
                <TrainingFileUploadButton buttonText="Upload Register"
                                          setFile={setFile} context={context}/>
                {!context.newTrainingSelected &&
                <StandardButton text="Download Register"
                                onClick={() => {
                                    handleFileDownloadClick(file)
                                }}/>}
            </div>
            <div className="training-capture-create-button-container">
                <StandardButton text={!context.newTrainingSelected ? "Save Training" : "Create Training"}
                                onClick={handleCreateOrUpdateTrainingClick}
                                disabled={(context.newTrainingSelected) ? !file : false}/>
                {!context.newTrainingSelected && <StandardButton text="Delete Training"
                                                                 onClick={handleDeleteModalShow}/>}
                {!context.newTrainingSelected && <StandardButton text="Back" onClick={navigateBack}/>}
            </div>
            {showModal &&
            <ConfirmDeleteModal showModal={showModal}
                                setShowModal={setShowModal}
                                titleToDelete={"training package"}
                                onDeleteClick={() => {
                                    handleDeleteTrainingClick(extRefToBeDeleted)
                                }}/>}
            <ReactModal isOpen={showTrainingModal} className="modal-content" overlayClassName="modal-overlay">
                <TrainingCaptureModal trainingModuleList={trainingModuleList}
                                      setTrainingModuleList={setTrainingModuleList}
                                      onUpdateClick={handleTrainingModalButtonClick}/>
            </ReactModal>
        </div>
    );
}
